/**
 * Component Registry
 * Maps component paths from manifests to actual React components
 */
import { lazy } from 'react';

// Lazy load components
const componentRegistry = {
  // Policy Module
  'pages/company/policy/PoliciesPage': lazy(() => import('@/pages/company/policy/PoliciesPage')),
  'pages/company/policy/PolicyEditorPage': lazy(() => import('@/pages/company/policy/PolicyEditorPage')),
  'pages/company/policy/PolicyCategoriesPage': lazy(() => import('@/pages/company/policy/PolicyCategoriesPage')),
  'pages/company/policy/PolicySubCategoriesPage': lazy(() => import('@/pages/company/policy/PolicySubCategoriesPage')),
  'pages/company/policy/PolicyReportsPage': lazy(() => import('@/pages/company/policy/PolicyReportsPage')),
  'pages/company/policy/EmployeePolicyPortalPage': lazy(() => import('@/pages/company/policy/EmployeePolicyPortalPage')),
  
  // Add more components as modules are added
  // This registry can be dynamically extended
};

/**
 * Get component by path
 * @param {string} path - Component path from manifest
 * @returns {React.Component|null} - Component or null if not found
 */
export const getComponent = (path) => {
  return componentRegistry[path] || null;
};

/**
 * Register a new component
 * @param {string} path - Component path
 * @param {React.Component} component - React component
 */
export const registerComponent = (path, component) => {
  componentRegistry[path] = component;
};

/**
 * Check if component is registered
 * @param {string} path - Component path
 * @returns {boolean}
 */
export const isComponentRegistered = (path) => {
  return path in componentRegistry;
};

export default componentRegistry;
